{
  "name": "Chain Booster Button",
  "powerupName": "ChainBonus",
  "levelUpDescriptions": [
    "ComboChainUpgradeDescription1",
    "ComboChainUpgradeDescription2",
    "ComboChainUpgradeDescription3",
    "ComboChainUpgradeDescription4",
    "ComboChainUpgradeDescription5"
  ]
}